import { Outlet } from 'react-router-dom';
import Content from '../../../components/content';
import { useSettingsResourceLayout } from '@/hooks/use-settings-resource-layout';

export function VisitTypesLayout() {
    const { headerTitle, backNavLink } = useSettingsResourceLayout({
        createPath: { path: '/settings/visit-type/create' },
        editPath: { path: '/settings/visit-type/:visitTypeId/edit' },
        listBackPath: '/settings/visit-types',
        labels: {
            list: 'Visit Types',
            create: 'New Visit Type',
            edit: 'Edit Visit Type',
        },
    });

    return (
        <Content headerTitle={headerTitle} backNavLink={backNavLink}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
